import { OVERVIEW_MAX_WINDOW_DAYS, OVERVIEW_WINDOW_DAYS } from '@steado/admin-contract/overview';
import { z } from 'zod';

/** Fewer than seven points is not a trend; more than ninety is a report. */
export const OVERVIEW_WINDOW_OPTIONS = [7, 30, 90] as const;

export const overviewSearchSchema = z.object({
  days: z.coerce
    .number()
    .int()
    .min(7)
    .max(OVERVIEW_MAX_WINDOW_DAYS)
    .default(OVERVIEW_WINDOW_DAYS)
    .catch(OVERVIEW_WINDOW_DAYS),
});

export type OverviewSearch = z.infer<typeof overviewSearchSchema>;
